import {
  FETCH_STR_CASE_REPORT_BY_CASE_ID,
  FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  CREATE_STR_CASE_REPORT_BY_CASE_ID,
  CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  CLOSE_SUCCESS_MODAL,
  CLOSE_ERROR_MODAL
} from '../../actions/cm/caseReport';

export const initialState = {
  isLoading: false,
  hasError: false,
  success: false,
  updateSuccess: false,
  caseReport: null,
  errorMessage: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_STR_CASE_REPORT_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        success: false,
        updateSuccess: false,
        caseReport: null,
        hasError: false
      };
    case FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        caseReport: payload,
        isLoading: false
      };
    case FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        caseReport: null,
        errorMessage: payload.message
      };
    case UPDATE_STR_CASE_REPORT_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        updateSuccess: false,
        hasError: false
      };
    case UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateSuccess: true
      };
    case UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        updateSuccess: false,
        errorMessage: payload.message
      };
    case CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        success: false,
        errorMessage: payload.message
      };

    case CREATE_STR_CASE_REPORT_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        success: false,
        hasError: false
      };
    case CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        success: true,
        caseReport: payload
      };
    case CLOSE_SUCCESS_MODAL:
      return {
        ...state,
        success: false,
        updateSuccess: false
      };
    case CLOSE_ERROR_MODAL:
      return {
        ...state,
        hasError: false
      };
    default:
      return state;
  }
}
